import { Injectable, OnDestroy } from '@angular/core';
import { Auth, Hub } from 'aws-amplify';
import { CognitoUserInterface } from '@aws-amplify/ui-components';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import {
  setUser,
  setAttributes,
  setSchoolName,
} from '../store/auth.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class SsoService implements OnDestroy {
  cognitoUser: CognitoUserInterface | undefined;
  constructor(
    private store: Store,
    private router: Router,
    private route : ActivatedRoute,
    private authService: AuthService
  ) {
    this.start();
    Hub.listen('auth', (data) => {
      const { payload } = data;
      if (payload.event === 'signIn') {
      } else if (payload.event === 'signOut') {
        this.store.dispatch(setUser({ payload: undefined }));
        this.store.dispatch(setAttributes({ payload: undefined }));
      }
    });
  }
  /**
   * Method to determine if the current user is logged in
   * @returns true if the current user is logged in or false if not
   */
  async isLoggedIn() {
    const user = await Auth.currentAuthenticatedUser();
    const authServiceLoggedIn = this.authService.isLoggedIn();
    if (user && authServiceLoggedIn) {
      return true;
    } else {
      return false;
    }
  }
  async signOut() {
    localStorage.removeItem('accessToken');
    localStorage.setItem('logout-event', Math.random().toString());
    await Auth.signOut();
  }
  async currentUser() {
    return await Auth.currentAuthenticatedUser();
  }

  async initiateLoginProcess(to: string, school: string) {
    const deployEnv = environment.environmentName;
    localStorage.setItem(
      'loginDetails',
      JSON.stringify({
        redirectURL: atob(to) || '',
        school: atob(school) || '',
      })
    );
    try {
      await this.store.dispatch(setSchoolName({ payload: atob(school) }));
      await Auth.federatedSignIn({
        customProvider: `idaas-okta-${deployEnv}-idp`,
      });
    } catch (error) {
      console.log('Unexpected error occured in Federated Sign in : ', error);
    }
  }
  protected ssoInitializeSession = () => {
    setTimeout(async () => {
      await this.signOut();
      this.router.navigate(['/sso-signout']);
    }, environment.autoSignOutTime * 60 * 1000);
  };

  private start() {
    window.addEventListener('storage', this.storageEventListener.bind(this));
  }

  storageEventListener = async (event: StorageEvent) => {
    if (
      event.storageArea === localStorage &&
      event.key &&
      event.key === 'logout-event'
    ) {
      localStorage.clear();
      await Auth.signOut();
    }
  };

  async postLoginRedirect() {
    await this.authService.generateAccessToken();
    this.ssoInitializeSession();
    const item = localStorage.getItem('loginDetails');
    const loginDetails = item ? JSON.parse(item) : null;
    const redirectTo = loginDetails?.redirectURL || '';
    localStorage.removeItem('loginDetails');
    this.router.navigate([redirectTo || atob(this.route.snapshot.queryParams['to'])]);
  }
  
  ngOnDestroy(): void {
    window.removeEventListener('storage', this.storageEventListener.bind(this));
  }
}
